import { z } from "zod";
import { ApplicationStatusSchema, ApplicationSchema } from "./application";

// ─── Response Schemas ─────────────────────────────────────────────────────────

export const PipelineResponseSchema = z.object({
  pipeline: z.record(ApplicationStatusSchema, z.array(ApplicationSchema)),
  counts: z.record(ApplicationStatusSchema, z.number().int().nonnegative()),
  total: z.number().int().nonnegative(),
});
export type PipelineResponse = z.infer<typeof PipelineResponseSchema>;

export const PaginatedPipelineResponseSchema = z.object({
  applications: z.array(ApplicationSchema),
  count: z.number().int(),
  nextKey: z.string().nullable(),
});
export type PaginatedPipelineResponse = z.infer<
  typeof PaginatedPipelineResponseSchema
>;
